export const apiUrl = "https://beachboard.herokuapp.com";
export const DEFAULT_MESSAGE_TIMEOUT = 3000;
